import React from 'react';
import { Spinner } from '../../components/ui';
import { INVITE_STATUSES, inviteChipClass, sideChipClass, fullName } from '../../utils/helpers';

// Mobile UI for Mark Status — a strip of the four counts that jumps to its
// section, then one card per member with the status as a 4-way switch
// (the current one lit; tap another to move the member).
export default function StatusMobile({ vm }) {
  const { isAdmin, canEdit, mine, rows, loading, grouped, mark } = vm;
  const jump = (e, status) => {
    e.preventDefault();
    document.getElementById(`gx-status-${status}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  return (
    <div>
      <div className="page-head" style={{ flexWrap: 'wrap' }}><h1>Mark Status</h1><span className="muted">{rows.length}</span></div>
      <div className="muted" style={{ marginBottom: 8, fontSize: 13 }}>
        {isAdmin ? 'All members.' : 'Members you added.'} Tap a status to move a member.
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : rows.length === 0 ? <div className="card card-pad empty">No members yet.</div> : (
          <>
            <div className="gx-m-status-jump">
              {INVITE_STATUSES.map(status => (
                <a key={status} href={`#gx-status-${status}`} onClick={(e) => jump(e, status)}>
                  <strong>{grouped[status].length}</strong>{status}
                </a>
              ))}
            </div>
            <div style={{ display: 'grid', gap: 14 }}>
              {INVITE_STATUSES.map(status => (
                <div key={status} id={`gx-status-${status}`} className="gx-m-status-sec">
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '0 0 6px 2px' }}>
                    <span className={inviteChipClass(status)}>{status}</span>
                    <span className="muted" style={{ fontSize: 13 }}>{grouped[status].length}</span>
                  </div>
                  {grouped[status].length === 0 ? (
                    <div className="muted" style={{ fontSize: 12, marginLeft: 2 }}>None.</div>
                  ) : (
                    <div style={{ display: 'grid', gap: 8 }}>
                      {grouped[status].map(row => (
                        <div key={row.GuestId} className="card gx-m-status-card">
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                            <strong style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{fullName(row)}</strong>
                            <div style={{ flex: 1 }} />
                            <span className={sideChipClass(row.Side)}>{row.Side}</span>
                          </div>
                          <div className="muted" style={{ fontSize: 13, marginTop: 4 }}>
                            📞 {row.MobileNumber || '—'} · {row.FunctionName || '—'}
                            {isAdmin && ` · by ${(row.AddedByName || row.InvitedByName || '').trim() || '—'}`}
                          </div>
                          {canEdit && (mine(row) ? (
                            <div className="gx-m-seg">
                              {INVITE_STATUSES.map(s => (
                                <button key={s} type="button" className={s === status ? 'on' : ''}
                                  aria-pressed={s === status} onClick={() => { if (s !== status) mark(row, s); }}>{s}</button>
                              ))}
                            </div>
                          ) : (
                            <div className="muted" style={{ fontSize: 12, marginTop: 8 }}>shared by another member</div>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
    </div>
  );
}
